import React, { Component } from 'react';

import { translate } from '../Services/translation';

class ProductQuantity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quantity: 1,
            quantityFieldId: this.props.quantityFieldId,
        };

        this.handleUpdateClick = this.handleUpdateClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleUpdateClick(event) {
        if (event.target.className === 'plus') {
            this.setState(prevState => ({
                quantity: prevState.quantity + 1
            }));
        } else if (event.target.className === 'minus') {
            if (this.state.quantity > 1) {
                this.setState(prevState => ({
                    quantity: prevState.quantity - 1
                }));
            }
        }
    }

    handleInputChange(event) {
        const value = parseInt(event.target.value, 10);
        if (!isNaN(value) && value >= 1) {
            this.setState({ quantity: value });
        } else {
            this.setState({ quantity: 1 });
        }
    }

    render() {
        return (
            <div className="product__quantity-wrapper">
                <button
                    type="button"
                    className="minus"
                    onClick={this.handleUpdateClick}
                >
                    &minus;
                </button>
                <div className="input-holder">
                    <input
                        className="product__buy-quantity"
                        type="number"
                        min="1"
                        value={this.state.quantity}
                        onChange={this.handleInputChange}
                        id={this.state.quantityFieldId}
                        aria-label={translate('product.quantity')}
                    />
                </div>
                <button
                    type="button"
                    className="plus"
                    onClick={this.handleUpdateClick}
                >
                    +
                </button>
            </div>
        );
    }
}

export default ProductQuantity;